<div (auxclick)="$event.button === 1 && open.emit($event)"
     (click)="open.emit($event)"
     (keydown.enter)="open.emit($any($event))"
     class="flex h-full cursor-pointer flex-col gap-2 rounded-lg border border-gray-200 bg-white p-3 transition-colors hover:bg-gray-50 hover:border-gray-300"
     role="link"
     tabindex="0">
  <div class="flex flex-row items-start gap-2 min-w-0">
    <div class="flex flex-1 flex-col gap-1 min-w-0">
      <span class="truncate text-sm font-medium text-gray-900" [title]="row.name">{{ row.name }}</span>
      <div class="flex flex-row items-center gap-3 min-w-0 text-xs text-gray-500">
        <span class="flex shrink-0 flex-row items-center gap-1">
          <fa-icon [icon]="faClockFive" class="text-svg-16 text-gray-400"></fa-icon>
          {{ row.check.checkDate | date:'dd.MM.yyyy HH:mm' }}
        </span>
        @if (row.check.checkerName) {
          <span class="flex flex-row items-center gap-1 min-w-0">
            <fa-icon [icon]="faUser" class="shrink-0 text-svg-16 text-gray-400"></fa-icon>
            <span class="truncate">{{ row.check.checkerName }}</span>
          </span>
        }
      </div>
    </div>
    @if (menu) {
      <!-- Das Menue oeffnet den Bericht nicht: Klicks darin (Trigger und Eintraege) erreichen die Karte nicht. -->
      <div (auxclick)="$event.stopPropagation()" (click)="$event.stopPropagation()"
           (keydown.enter)="$event.stopPropagation()" class="shrink-0">
        <ng-container *ngTemplateOutlet="menu; context: {$implicit: row}"></ng-container>
      </div>
    }
  </div>

  <!-- Badges bleiben in einer Zeile: nur das myChecks-Badge schrumpft und kuerzt den Namen. -->
  <div class="flex flex-row flex-nowrap items-center gap-2 min-w-0">
    <app-report-mychecks-badge [row]="row" class="min-w-0"></app-report-mychecks-badge>
    <app-report-files-badge [files]="row.files" class="shrink-0"></app-report-files-badge>
    <bic-badge [type]="row.badgeType" class="shrink-0 ml-auto">{{ row.statusLabel }}</bic-badge>
  </div>
</div>
